import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=494794cd&scoped=true"
import script from "./Restrictions.vue?vue&type=script&lang=ts"
export * from "./Restrictions.vue?vue&type=script&lang=ts"
import style0 from "./Restrictions.vue?vue&type=style&index=0&id=494794cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494794cd",
  null
  
)

export default component.exports